import cx from 'classnames';
import { useState } from 'react';
import { EditIcon } from '../../components/icons/EditIcon';
import { EditForm } from './EditForm';
import { FormButtons } from './FormButtons';
import styles from './EditSection.module.scss';
import BinIcon from '../../components/icons/BinIcon';

export const EditSection = ({
  title,
  fields,
  previewMode,
  layout,
  designV2 = false
}) => {
  const [editMode, setEditMode] = useState(true);

  const formVisible = editMode || previewMode === 'fields';
  const hasLabelMargin = formVisible;
  const titleHidden = layout === 'oneliner' && formVisible;

  return (
    <section className={cx(styles.root, layout === 'oneliner' && styles.oneliner, designV2 ? styles.designV2 : '')}>
      {!titleHidden && (
        <div className={cx(styles.title, hasLabelMargin && styles.mb)}>
          {title}
        </div>
      )}

      <div>
        <EditForm
          fields={fields}
          layout={layout}
        />
      </div>
    </section>
  );
};

EditSection.FormButtons = FormButtons;
